/**
 * Yüzde halkası. İz ve yazı rengi temaya göre sınıfla verilir (koyuda açık
 * yazı, soluk iz); `track` verilirse iz o renkle çizilir.
 */
export default function ProgressRing({ value = 0, size = 64, stroke = 6, color = "#1A5D1A", track, fillClassName }) {
  const safe = Math.max(0, Math.min(100, value));
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const offset = c - (safe / 100) * c;
  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} role="img" aria-label={`%${safe}`}>
      <circle
        cx={size / 2}
        cy={size / 2}
        r={r}
        stroke={track}
        strokeWidth={stroke}
        fill="none"
        className={track ? undefined : "stroke-[#E2E8F0] dark:stroke-white/[0.12]"}
      />
      <circle
        cx={size / 2}
        cy={size / 2}
        r={r}
        stroke={color}
        strokeWidth={stroke}
        fill="none"
        className={fillClassName}
        strokeDasharray={c}
        strokeDashoffset={offset}
        strokeLinecap="round"
        transform={`rotate(-90 ${size / 2} ${size / 2})`}
      />
      <text x="50%" y="52%" dominantBaseline="middle" textAnchor="middle" fontSize={size / 4} fontWeight="700" className="fill-[#222831] dark:fill-white">
        %{Math.round(safe)}
      </text>
    </svg>
  );
}
